<template>
  <div class="ui form" ref="form">
    <div class="ui pointing secondary menu">
      <a class="item active" data-tab="general">
        <i class="info icon"></i>
        {{ $t("general") }}
      </a>
      <a class="item" data-tab="listeners">
        <i class="code icon"></i>
        {{ $t("listeners") }}
      </a>
      <a class="item" data-tab="notifications">
        <i class="alert sign icon"></i>
        {{ $t("notifications") }}
      </a>
    </div>
    <div class="ui bottom attached tab segment active" data-tab="general">
      <div class="field">
        <label for>{{ $t("name") }}</label>
        <input type="text" name="name" v-model="setup.name" />
      </div>
    </div>
    <div class="ui bottom attached tab segment" data-tab="listeners">
      <div class="ui info message" style="display: block">
        <div class="header">{{ $t("hints") }}</div>
        <ul class="list">
          <li v-html="$t('use D to refer data objects')"></li>
          <li v-html="$t('use T to refer task data')"></li>
        </ul>
      </div>
      <div class="field">
        <label for>{{ $t("on execute") }}</label>
        <editor
          @init="init_editor('javascript')"
          v-model="setup.listeners.on_execute"
          lang="javascript"
          theme="monokai"
        ></editor>
      </div>
    </div>
    <div class="ui bottom attached tab segment" data-tab="notifications">
      <notifications-manager :events="events" :notifications="setup.notifications" />
    </div>
    <button class="ui green labeled icon fluid button" type="button" @click="ok">
      <i class="ui check icon"></i>
      {{ $t("ok") }}
    </button>
    <div class="ui error message"></div>
  </div>
</template>

<script>
import Editor from "vue2-ace-editor";
import { clone } from "@/utils";
import NotificationsManager from "../NotificationsManager";
import { isEmpty } from "lodash";

export default {
  name: "ScriptTaskElementSidebar",
  components: { Editor, NotificationsManager },
  data() {
    return {
      setup: {
        name: "",
        listeners: {
          on_execute: ""
        },
        notifications: []
      },
      events: [
        { display: this.$t("end"), value: "end" },
        { display: this.$t("start"), value: "start" }
      ],
      form: undefined
    };
  },
  props: { process: Object, element: Object, project: Object },
  mounted() {
    let vm = this;
    window
      .jQuery(vm.$el)
      .find(".pointing.menu .item")
      .tab();

    vm.form = window.jQuery(vm.$refs.form).form({
      fields: {
        name: ["empty"]
      }
    });

    let conf = vm.$props.element.ngine_configuration;
    if (!isEmpty(conf)) {
      vm.setup = clone(conf);
      vm.setup.notifications = vm.setup.notifications || [];
    }
  },
  methods: {
    ok() {
      let isValid = this.form.form("validate form");

      if (isValid) {
        this.$emit("ok", this.setup);
      }
    },
    cancel() {
      this.$emit("cancel");
    },
    init_editor(type) {
      require(`brace/mode/${type}`);
      require("brace/theme/monokai");
    }
  },
  computed: {}
};
</script>

<style>
.hidden {
  display: none !important;
}
</style>
